import { render, staticRenderFns } from "./ServerInfoView.vue?vue&type=template&id=2a52e88a&scoped=true"
import script from "./ServerInfoView.vue?vue&type=script&lang=js"
export * from "./ServerInfoView.vue?vue&type=script&lang=js"
import style0 from "./ServerInfoView.vue?vue&type=style&index=0&id=2a52e88a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a52e88a",
  null
  
)

export default component.exports